import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { Insurance } from './Insurance.types';

export function useInsuranceData(): Page<Insurance>['templateFields'] {
  return useCurrentPage<Page<Insurance>>().templateFields;
}
